import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
// import { RptloanpopupComponent } from "../../../shared/popup/rptloanpopup/rptloanpopup.component";

import { CommonmastersService } from "../../../../commonmasters/commonmasters.service";
import { PrintcustomerService } from "../../../shared/report/printcustomer.service";

@Component({
  selector: 'app-rptcustomerpopup',
  templateUrl: './rptcustomerpopup.component.html',
  styleUrls: ['./rptcustomerpopup.component.css']
})
export class RptcustomerpopupComponent implements OnInit {

  LoanTypeList: any[] = [];
  SchemeList: any[] = [];
  BranchList: any[] = [];
  CentreList: any[] = [];
  CategoryList: any[] = [];

  constructor(public dialogRef: MatDialogRef<RptcustomerpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private CommonmastersService: CommonmastersService,
    private printcustomerService: PrintcustomerService,) { }

  ngOnInit() {

    this.GetScheme()
    this.GetLoanType();
    this.GetBranch();
    this.GetCentre();
    this.GetCategory();
  }

  GenerateReports(): void {
    this.data.ReportName = "CustomerReport";
    this.printcustomerService.getRptLoanList(this.data);
    this.dialogRef.close();
  }

  GetScheme() {
    this.CommonmastersService.FetchScheme().subscribe(data => {
      this.SchemeList = data;
    })
  }

  GetLoanType() {
    this.CommonmastersService.FetchLoanType().subscribe(data => {
      this.LoanTypeList = data;
    })
  }

  GetCategory() {
    this.CommonmastersService.GetCategoryList().subscribe(data => {
      this.CategoryList = data;
    })
  }

  GetBranch() {
    this.CommonmastersService.GetBranchList().subscribe(data => {
      this.BranchList = data;
    })
  }

  GetCentre() {
    this.CommonmastersService.FetchCenterList().subscribe(data => {
      this.CentreList = data;
    })
  }

}
